import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common_ru from './translations/ru/common.json';
import common_en from './translations/en/common.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  ru: {
    common: common_ru,
  },
  en: {
    common: common_en,
  },
};

const defaultLang = 'ru';
let lang = localStorage.getItem('lang');
if (!lang) {
  lang = defaultLang;
}

i18n.use(initReactI18next).init({
  ns: ['common'],
  lng: lang,
  defaultNS: 'common',
  resources,
  fallbackLng: defaultLang,
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
